import { useAuthStore } from 'modules/auth/store/authStore';
import { MeasurementKey } from 'modules/profiling/measurementTypes';
import { profilingStoreActions } from 'modules/profiling/profilingStore';
import { waitForSettingSyncToLoad } from 'modules/settings-sync/helpers';

import { useVoiceStore } from '../voicesStore';

export const fetchInitialVoice = async () => {
  await profilingStoreActions.measureAction(() => useVoiceStore.waitForInitialHydration(), {
    measurementKey: MeasurementKey.zustandIdbHydration,
    identifier: {},
    context: {
      storeName: 'voicesStore'
    }
  });
  const user = useAuthStore.getState().user;
  if (user && !user.isAnonymous) {
    await waitForSettingSyncToLoad();
  }
  return useVoiceStore.getState().lastPlayingVoice;
};
